import { Helmet } from "react-helmet-async";

const SITE_URL = "https://arandialawfirm.com";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Arandia Law Firm",
  url: SITE_URL,
  inLanguage: ["en", "pt", "es"],
  publisher: {
    "@type": "LegalService",
    name: "Arandia Law Firm",
    url: SITE_URL,
  },
};

const faqs: { q: string; a: string }[] = [
  {
    q: "What is 'Crimmigration' law?",
    a: "It is the specialized intersection of criminal defense and immigration law. We focus on protecting non-citizens who are facing criminal charges that could lead to deportation or affect their Green Card status.",
  },
  {
    q: "Do you offer services in Portuguese and Spanish?",
    a: "Yes. Our entire team is trilingual. You can discuss your case comfortably in English, Portuguese, or Spanish without the need for translators.",
  },
  {
    q: "Can I still get a Green Card if I have a criminal record?",
    a: "It depends on the specific charges. Many crimes can be waived or vacated with the right legal strategy. We specialize in analyzing your record to find a path forward.",
  },
  {
    q: "Do I need to come to the office for a consultation?",
    a: "Not necessarily. We offer virtual consultations via video call for clients across New Jersey, New York, and internationally, as well as in-person meetings at our Kew Gardens and NJ offices.",
  },
  {
    q: "Do I need to live in NY or NJ to hire you?",
    a: "No. For Federal Immigration cases, we can represent clients in all 50 states. We offer secure virtual consultations and handle your case remotely.",
  },
  {
    q: "Do you offer payment plans?",
    a: "Yes. We understand that legal battles are unexpected. We offer flexible payment plans to ensure you get the defense you deserve.",
  },
  {
    q: "How quickly can I speak to an attorney?",
    a: "We prioritize urgent cases. If you are detained or have an upcoming court date, mention this in your contact form for priority scheduling.",
  },
  {
    q: "Do you speak my language?",
    a: "Yes. Our entire team is fluent in English, Spanish, and Portuguese. You will never need to pay for an outside translator.",
  },
];

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const HomeStructuredData = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
    <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
  </Helmet>
);

export default HomeStructuredData;
